// src/js/common/gsap.js
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/* =========================
   GSAP Plugin Register
========================= */

if (!gsap.core.globals().ScrollTrigger) {
  gsap.registerPlugin(ScrollTrigger);
}

/* =========================
   Export
========================= */

export { gsap, ScrollTrigger };